import axiosInstance from '../helpers/axiosInstance'

// Self-service warehouse configuration (platform WarehouseConfigurationsController).
const configurationsUrl = warehouseId => `${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouseId}/configurations`
const storeOverridesUrl = (warehouseId, key) => `${configurationsUrl(warehouseId)}/${key}/store-overrides`

export const fetchWarehouseConfigurations = async warehouseId => {
  const res = await axiosInstance.get(configurationsUrl(warehouseId))
  return res.data
}

export const updateWarehouseConfigurations = async (warehouseId, configurations) => {
  const res = await axiosInstance.patch(configurationsUrl(warehouseId), { configurations })
  return res.data
}

export const fetchStoreOverrides = async (warehouseId, key) => {
  const res = await axiosInstance.get(storeOverridesUrl(warehouseId, key))
  return res.data
}

export const upsertStoreOverride = async (warehouseId, key, storeId, value) => {
  const res = await axiosInstance.put(`${storeOverridesUrl(warehouseId, key)}/${storeId}`, { value })
  return res.data
}

export const deleteStoreOverride = async (warehouseId, key, storeId) => {
  await axiosInstance.delete(`${storeOverridesUrl(warehouseId, key)}/${storeId}`)
}
